exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-cb149ef2] {\n    font-size: 12px;\n}\n", ""]);

// exports
